import React from "react";
import iconExcel from "../../img/icons-ext-file/iconExcel.png"

export default function FileExcel() {
    return (
        <img src={iconExcel} alt="" />
    );
}